import React from 'react'
import DashboardLayout from './../../components/Admin/DashboardLayout'
import { MDBCol, MDBContainer } from 'mdb-react-ui-kit'
import TechToolWidget from './components/TechToolWidget/TechToolWidget.component'
import { Subscription } from 'rxjs'
import AdminApi from './../../api/admin-api/admin-api'
import DeniedAccessModal from './components/DeniedAccessModal/DeniedAccessModal.component'
import CorpEmailManager from './../../components/agents/CorporateEmails/CorpEmailManager.component'
import UserProfileService from './../../shared/services/UserProfile.service'
import env from './../../environments/environment'

import './TechToolsPage.scss'

const sortTools = tools => {
  console.log('sortTools input:', tools)

  if (!tools || !Array.isArray(tools)) {
    console.warn('sortTools: invalid input, returning empty array')
    return []
  }

  let fs = tools.filter(t => t && t.fullscreen) || [],
    rg = tools.filter(t => t && !t.fullscreen) || []

  console.log('sortTools: fullscreen tools:', fs.length, 'regular tools:', rg.length)

  const sortedTools = fs
    .sort((a, b) =>
      a.tool_title > b.tool_title
        ? 1
        : a.tool_title.toLowerCase().charAt(0) === b.tool_title.toLowerCase().charAt(0)
        ? 0
        : -1
    )
    .concat(
      rg.sort((a, b) =>
        a.tool_title > b.tool_title
          ? 1
          : a.tool_title.toLowerCase().charAt(0) === b.tool_title.toLowerCase().charAt(0)
          ? 0
          : -1
      )
    )

  console.log('sortTools output:', sortedTools.length, 'tools')
  return sortedTools
}

class TechToolsPage extends React.Component {
  state = {
    isLoading: true,
    imageUris: {},
    techToolsList: [],
    User: null,
    error: null,
  }

  #_subscriptions$ = new Subscription()

  #fetchTechToolsData = async () => {
    let techToolsList = {
      imageUris: { prefix: null, suffix: null },
      techToolsList: [],
    }
    try {
      console.log('Fetching tech tools data...')
      console.log('UserProfileService.getUserId():', UserProfileService.getUserId())
      console.log('UserProfileService.getCurrentUserTypeId():', UserProfileService.getCurrentUserTypeId())

      let response = await AdminApi.getTechToolsList()
      console.log('Tech tools response:', response)

      if (!response || !response.data) {
        throw new Error('Invalid response from API')
      }

      techToolsList = {
        techToolsList: response?.data?.data || [],
        imageUris: response?.data?.imageUrl,
      }

      console.log('Processed tech tools data:', techToolsList)
    } catch (ex) {
      console.error('Error fetching tech tools:', ex)
      console.error('Error details:', {
        message: ex.message,
        stack: ex.stack,
        response: ex.response,
        status: ex.response?.status,
        data: ex.response?.data,
      })

      let errorMessage = 'Failed to load tech tools'
      if (ex.response?.status === 403) {
        errorMessage = 'Access denied. You may not have permission to view tech tools.'
      } else if (ex.response?.status === 401) {
        errorMessage = 'Authentication required. Please log in again.'
      } else if (ex.message) {
        errorMessage = ex.message
      }

      this.setState({ error: errorMessage })
    }

    this.setState({
      imageUris: techToolsList.imageUris,
      techToolsList: sortTools(Array.isArray(techToolsList.techToolsList) ? techToolsList.techToolsList : []),
      isLoading: false,
    })
  }

  componentDidMount() {
    console.log('TechToolsPage componentDidMount')
    this.#fetchTechToolsData()

    // Add error handling for UserProfileService.instance()
    UserProfileService.instance()
      .then(User => {
        console.log('User loaded:', User)
        this.setState({ User })
      })
      .catch(error => {
        console.error('Error loading user:', error)
        this.setState({ error: 'Failed to load user profile' })
      })
  }

  render() {
    const { techToolsList, isLoading, imageUris, error } = this.state

    console.log('TechToolsPage render state:', {
      isLoading,
      error,
      techToolsListLength: techToolsList?.length,
      imageUris,
      User: !!this.state.User,
    })

    // Show error state if there's an error
    if (error) {
      return (
        <DashboardLayout>
          <main id='TechToolsPage' className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <h2 className='text-center text-danger'>Error Loading Tech Tools</h2>
              <p className='text-center'>{error}</p>
              <div className='text-center'>
                <button className='btn btn-primary' onClick={() => window.location.reload()}>
                  Reload Page
                </button>
              </div>
            </MDBContainer>
          </main>
        </DashboardLayout>
      )
    }

    // Always render something to prevent white page
    return (
      <React.Fragment>
        <DashboardLayout>
          <main id='TechToolsPage' className='mainSection'>
            <DeniedAccessModal />
            <MDBContainer fluid className='mt-5'>
              <h2 className='text-center'>Tech Tools for Success</h2>
              <hr />
              <div className='header-img'>
                <img
                  src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fimg.header.tech-tools.jpg?alt=media`}
                  alt="Not Yo Grandpa's Tools!"
                  onError={e => {
                    console.error('Failed to load header image')
                    e.target.style.display = 'none'
                  }}
                />
              </div>
            </MDBContainer>
            {isLoading ? (
              <MDBContainer fluid className='mt-5'>
                <h2>Loading Tech Tools...</h2>
                <p>Please wait while we fetch your available tools.</p>
              </MDBContainer>
            ) : (
              <MDBContainer fluid className='mt-5'>
                <div className='row'>
                  {/* CorpEmailManager Widget */}
                  <MDBCol md={'6'} className='mb-4'>
                    <TechToolWidget component={<CorpEmailManager User={this.state.User} />} />
                  </MDBCol>

                  {/* Tech Tools */}
                  {techToolsList && techToolsList.length > 0 ? (
                    techToolsList.map((item, i) => (
                      <MDBCol key={`tool-${item.id || i}`} md={item.fullscreen ? '12' : '6'} className='mb-4'>
                        <TechToolWidget source={item} imageUris={imageUris} />
                      </MDBCol>
                    ))
                  ) : (
                    <MDBCol size='12'>
                      <div className='text-center'>
                        <h2>No Tools Available</h2>
                        <p>There are currently no tech tools available for your account.</p>
                        <p>Please check back later or contact support if you believe this is an error.</p>
                      </div>
                    </MDBCol>
                  )}
                </div>
              </MDBContainer>
            )}
          </main>
        </DashboardLayout>
      </React.Fragment>
    )
  }
}

export default TechToolsPage
